export const PURPLE_HIGHLIGHT = "#9146FF";
export const DARKMODE_BG = "#18181b";
export const DARKMODE_TEXT = "#efeff1";
export const DARKMODE_BORDER = "rgba(255, 255, 255, 0.1)";

export const DARKMODE_SUBTITLE = "rgb(173, 173, 184)";
export const TITLE_PURPLE_HIGHLIGHT = "rgb(191, 148, 255)";

export const APP_BACKGROUND = "#0e0e10";

export const NAVBAR_COLOR = "rgb(24, 24, 27)";
